import { useAuth } from "../contexts/AuthContext";
import { RequestProjectRefreshAsync } from "../services/ProjectsService";

export function useProjects() {
  const { instance, account } = useAuth();

  async function refreshProject(crmProjectId: string): Promise<void> {
    if (crmProjectId === "") return;

    try {
      await RequestProjectRefreshAsync(instance, account, crmProjectId);
    } catch (ex) {
      console.log(ex);
      throw new Error();
    }
  }

  return { refreshProject };
}
